import { Settings2, Link2, LifeBuoy, Lightbulb, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { servicesTech } from "@/assets/images";

const TECH_IMG = servicesTech;

const SERVICES = [
  {
    icon: Settings2,
    title: "Product Customization",
    desc: "Tailor PixTraya and companion products to your studio's exact workflow — custom fields, branding, automation recipes, and role-based access.",
    bullets: ["Custom workflows", "White-label client galleries", "Branded email & invoicing templates"],
  },
  {
    icon: Link2,
    title: "Integration Services",
    desc: "Seamless integrations with your accounting, storage, CRM, and communications stack — delivered by our solution engineering team.",
    bullets: ["Accounting (Tally, Zoho, QuickBooks)", "Cloud storage (GCS, S3, Drive)", "CRM & marketing platforms"],
  },
  {
    icon: LifeBuoy,
    title: "Technical Support",
    desc: "Enterprise-grade support with guaranteed SLAs, dedicated success managers, and 24/7 critical incident response for enterprise plans.",
    bullets: ["24/7 incident response", "Dedicated customer success", "Quarterly workflow reviews"],
  },
  {
    icon: Lightbulb,
    title: "Consulting",
    desc: "Strategic advisory on digital transformation, workflow automation, and scaling creative operations — delivered by senior practitioners.",
    bullets: ["Workflow audit & mapping", "Automation strategy", "Change management"],
  },
];

const Services = () => {
  return (
    <div data-testid="page-services">
      <section className="border-b border-slate-200 bg-slate-50">
        <div className="container-section grid items-center gap-12 py-16 md:py-24 lg:grid-cols-2">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#0046B5]">Services</span>
            <h1 className="mt-3 text-4xl font-bold leading-tight tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
              Partnership beyond the <span className="brand-gradient-text">product</span>.
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600 md:text-lg">
              Our services team works alongside your studio to customize, integrate, and optimize Ortelly products for the realities of your operation.
            </p>
            <div className="mt-8">
              <Button asChild data-testid="services-cta-contact" className="rounded-md bg-[#0046B5] text-white hover:bg-[#003A99]">
                <Link to="/contact">Talk to our team <ArrowRight className="ml-2 h-4 w-4" /></Link>
              </Button>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-slate-200 shadow-sm">
            <img src={TECH_IMG} alt="Integration services" className="h-full w-full object-cover" />
          </div>
        </div>
      </section>

      <section className="container-section py-16 md:py-24">
        <div className="grid gap-6 md:grid-cols-2">
          {SERVICES.map((s) => (
            <div key={s.title} data-testid={`service-${s.title.toLowerCase().replace(/\s+/g,'-')}`} className="group rounded-md border border-slate-200 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#0046B5]/40 hover:shadow-md">
              <div className="flex items-center gap-4">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-[#0046B5]/10 text-[#0046B5] transition-colors group-hover:bg-[#0046B5] group-hover:text-white">
                  <s.icon className="h-5 w-5" />
                </div>
                <h2 className="text-xl font-semibold text-slate-900">{s.title}</h2>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-slate-600">{s.desc}</p>
              <ul className="mt-5 space-y-2">
                {s.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-2 text-sm text-slate-700">
                    <span className="mt-1.5 inline-block h-1.5 w-1.5 rounded-full bg-[#00C4B5]" /> {b}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Services;
